import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import cx from 'classnames';
import React from 'react';
import { IFeeWaiverHistoryItem } from './interfaces';

const FeeWaiverHistoryLoadingItem: React.FC<IFeeWaiverHistoryItem> = ({ isLastItem }) => {
  return (
    <div
      className={cx('py-6 border-0 border-dashed border-border', {
        'border-b': !isLastItem
      })}
    >
      <div className="flex justify-between">
        <LineLoader numberOfLines={1} lineStyle="w-[150px] h-2" />
        <LineLoader numberOfLines={1} lineStyle="w-[70px] h-2" />
      </div>
      <LineLoader numberOfLines={1} lineStyle="w-[70px] h-2 mt-2" />
      <LineLoader numberOfLines={1} lineStyle="w-[70px] h-2 mt-2" />
    </div>
  );
};

export default FeeWaiverHistoryLoadingItem;
